/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export function BlogData() {
    const blogArray = [
        {
            blogTitle: '5 BEST PLANTS FOR YOUR COLLEGE DORM ROOM',
            blogDate: 'July 29, 2022',
            blogContent: 'Spruce up your new living space with some living décor. Plants not only look great, but they’ll help freshen your dorm room.',
            blogImg: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt490be26a1ef8549e/6384465f0d85671097f1c34e/related_blog_post_2.jpeg',
            blogLink: 'https://www.plants.com/greenhouse/plant-care/5-best-plants-for-your-college-dorm-room/',
        },
        {
            blogTitle: '7 Plants for Beginners',
            blogDate: 'July 12, 2022',
            blogContent: 'Houseplants can improve the quality of indoor air, leaving rooms smelling purer and fresher. According to NASA, they effectively filter potentially harmful volatile organic compounds (VOCs) — such as benzene, formaldehyde, and xylene — from the air.',
            blogImg: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt650ffeb81179ba8d/63844698acdace1077593af1/GettyImages-991006668-min.jpeg',
            blogLink: 'https://www.plants.com/greenhouse/plant-care/plants-for-beginners/',
        },
        {
            blogTitle: 'How Plants Help to Clean the Air',
            blogDate: 'June 21, 2022',
            blogContent: 'With their large, glossy leaves or tropical flowers, houseplants add a pop of color to any space. Plus, they are good for our minds, bodies and souls.',
            blogImg: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltf2c5d2e83c2343c9/638446cef213ef108ebd94b6/GettyImages-953779982-min.jpeg',
            blogLink: 'https://www.plants.com/greenhouse/plant-facts/how-plants-purify-the-air/',
        },
    ];
    return blogArray;
}

export function BlogSliderSetting() {
    const blog_slider_settings = {
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        adaptiveHeight: true,
        centerPadding: '0',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return blog_slider_settings;
}
